import { createSlice } from "@reduxjs/toolkit";

const PROMO_BAR_STORAGE_KEY = "ui:showPromoBar";

const getInitialPromoBarState = (): boolean => {
	try {
		const stored = localStorage.getItem(PROMO_BAR_STORAGE_KEY);
		if (stored !== null) {
			return JSON.parse(stored);
		}
	} catch {
		// localStorage not available or parse error
	}
	return true; // Default to showing
};

interface UIState {
	showPromoBar: boolean;
}

const initialState: UIState = {
	showPromoBar: getInitialPromoBarState(),
};

export const UISlice = createSlice({
	name: "ui",
	initialState,
	reducers: {
		setShowPromoBar: (state, action: { payload: boolean }) => {
			state.showPromoBar = action.payload;
			try {
				localStorage.setItem(
					PROMO_BAR_STORAGE_KEY,
					JSON.stringify(action.payload),
				);
			} catch {
				// localStorage not available
			}
		},
		hidePromoBar: (state) => {
			state.showPromoBar = false;
			try {
				localStorage.setItem(PROMO_BAR_STORAGE_KEY, "false");
			} catch {
				// localStorage not available
			}
		},
		showPromoBar: (state) => {
			state.showPromoBar = true;
			try {
				localStorage.setItem(PROMO_BAR_STORAGE_KEY, "true");
			} catch {
				// localStorage not available
			}
		},
	},
});

export const { setShowPromoBar, hidePromoBar, showPromoBar } = UISlice.actions;
